import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Breadcrumbs from "@/components/vr/Breadcrumbs";
import Seo from "@/components/vr/Seo";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [sp, setSp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const [data, setData] = useState({ notes: [], quizzes: [], blog: [], subjects: [] });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const query = sp.get("q");
    if (query && query.length >= 2) {
      setLoading(true);
      api.get(`/search?q=${encodeURIComponent(query)}`).then((r) => setData(r.data)).finally(() => setLoading(false));
    }
  }, [sp]);
  const submit = (e) => { e.preventDefault(); if (q.length >= 2) setSp({ q }); };
  const empty = !loading && data.notes.length + data.quizzes.length + data.blog.length + data.subjects.length === 0;
  const query = sp.get("q");
  return (
    <div className="vr-container my-8">
      <Seo
        title={query ? `Search: ${query}` : "Search"}
        description="बिहार बोर्ड study material — Notes, MCQ, Blog एवं YouTube videos खोजें।"
        canonical="/search"
        noindex
      />
      <Breadcrumbs items={[{ label: "Search" }]} />
      <h1 className="font-display font-extrabold text-3xl text-[#0F172A]">Search</h1>
      <form onSubmit={submit} className="mt-4 flex items-center bg-white border border-slate-200 rounded-lg h-12 px-4 max-w-xl">
        <SearchIcon size={18} className="text-slate-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Notes, MCQ, Blog खोजें..." className="bg-transparent outline-none px-3 flex-1" data-testid="search-page-input" />
        <button className="text-sm font-semibold text-[#1E3A8A]" data-testid="search-page-submit">Search</button>
      </form>
      {loading && <div className="mt-6 text-slate-500">खोज रहे हैं...</div>}
      {empty && query && <div className="mt-6 text-slate-500">कोई परिणाम नहीं मिला।</div>}
      {["notes", "quizzes", "blog", "subjects"].map((k) => data[k]?.length > 0 && (
        <section key={k} className="mt-8">
          <h2 className="font-display font-bold text-xl capitalize">{k}</h2>
          <div className="mt-3 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
            {data[k].map((it) => (
              <Link key={it.id} to={k === "blog" ? `/blog/${it.slug}` : k === "quizzes" ? `/quiz/${it.slug}` : k === "subjects" ? `/subjects/${it.slug}` : `/notes/${it.slug}`} className="vr-card p-4" data-testid={`search-${k}-${it.slug}`}>
                <h3 className="font-semibold text-[#0F172A] text-base">{it.title || it.name}</h3>
                {it.intro && <div className="text-xs text-slate-500 mt-1 line-clamp-2 font-hindi">{it.intro}</div>}
                {it.excerpt && <div className="text-xs text-slate-500 mt-1 line-clamp-2">{it.excerpt}</div>}
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
